/* eslint-disable */
// @ts-nocheck

import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import axios from 'axios';
import GlobalStyles from '~/themes/global';
import Themes from '~/themes/themes';
import AppProvider from './contexts';

import Routes from './routes';
import Constants from './utils/constants';

import { ChatProvider } from './contexts/chat';
import ChatDrawer from './views/Agent/ChatDrawer';
import TeoBubble from './views/Agent/teoBubble';
import { useAuth } from './hooks/contexts/useAuth';
import useAuditCorrelation from './hooks/useAuditCorrelation';

function App(): JSX.Element {

  useEffect(() => {
    const getData = async () => {
      const res = await axios.get('https://api.ipify.org/?format=json');
      localStorage.setItem(Constants.IP_ADRESS, res.data.ip);
    };
    getData();
  }, []);

  return (
    <BrowserRouter>
      <ThemeProvider theme={Themes}>
        <GlobalStyles />
        <AppProvider>
          <Content />
        </AppProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

function Content() {
  const { isAuthenticated } = useAuth();
  useAuditCorrelation();

  return (
    <ChatProvider>
      <ChatDrawer />
      <Routes />
      {isAuthenticated() && <TeoBubble />}
    </ChatProvider>
  );
}

export default App;
